import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import { C as Collection } from './collection-BVmJhEYo.js';
import './uniq-BDEfcc0N.js';
import './fetchHTML-CGNR3V1z.js';
import './parseHTML-Om2c1Ayj.js';

class SortBy extends HTMLElement {
  #sortElements = this.querySelectorAll('sort-by');

  connectedCallback() {
    this.addEventListener('change', (event) => this.#updateSortElements(event));
  }

  /**
   * Update sort elements
   * @param {Object} event - Change event
   * @param {Object} event.target - Change event target
   *
   * @description Update all collection sort elements when the sort is changed
   */
  async #updateSortElements({ target: { value } }) {
    try {
      await this.#filterCollection(value);

      this.#sortElements = this.#sortElements || document.querySelectorAll('sort-by');

      // The 'element' variable is the current collection sort element. E.g. <sort-by>
      this.#sortElements.forEach((element) => {
        // The 'select' variable is the select element inside the current collection sort element
        const select = element.querySelector('select');
        select.value = value;
      });

      PubSub.publish('sort:change', { data: { value } });
    } catch (error) {
      console.error('Error updating sort elements:', error);
      PubSub.publish('sort:change', { status: 'error', error });
    }
  }

  /**
   * Filter the collection
   * @param {string} value - The value of the sort by
   * @async
   * @returns {Promise<void>}
   */
  async #filterCollection(value) {
    const url = new URL(window.location);

    // Set the sort_by parameter and delete it if the value is empty
    url.searchParams.set('sort_by', value);
    if (!value) url.searchParams.delete('sort_by');

    await Collection.filter(url);
  }
}

customElements.define('sort-by', SortBy);
